import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { TeamBuilder } from '../components/teams/TeamBuilder';
import { TeamCreate } from '../types/team';
import * as teamService from '../services/teamService';

export const NewTeam: React.FC = () => {
  const navigate = useNavigate();
  
  const createTeamMutation = useMutation(
    (team: TeamCreate) => teamService.createTeam(team),
    {
      onSuccess: (data) => {
        navigate(`/teams/${data.id}`);
      }
    }
  );
  
  const handleSaveTeam = (team: TeamCreate) => {
    createTeamMutation.mutate(team);
  };
  
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Create New Team</h1>
      </div>
      
      {createTeamMutation.isError && (
        <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-md">
          Error creating team: {createTeamMutation.error.message}
        </div>
      )}
      
      <TeamBuilder onSave={handleSaveTeam} />
    </div>
  );
};
